export const farmProfileRoutesConfig = {
    base: '',
} as const;
